import script from "./privacy_policy_confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy_policy_confirmation.vue?vue&type=script&setup=true&lang=js"

import "./privacy_policy_confirmation.vue?vue&type=style&index=0&id=a8cda804&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8cda804"]])

export default __exports__